import { Lightning, Log } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';

const Constants = {
  Bar: {
    h: 4,
  },
  Pointer: {
    size: 24,
  },
  CurrentTime: {
    Left: 60,
    Top: 60,
  },
  RemainingTime: {
    Left: 1700,
    Top: 35,
  },
};
export class Seekbar extends Lightning.Component {
  static _template() {
    return {
      w: w => w,
      ProgressBar: {
        rect: true,
        w: w => w * 0.8,
        x: w => w * 0.06,
        y: 35,
        mountY: 0.5,
        h: Constants.Bar.h,
        color: Theme.Colors.Player.Background.Seekbar.Default,
        ProgressFill: {
          rect: true,
          w: 0,
          h: h => h,
          color: Theme.Colors.Player.Controls.Seekbar.Fill.Default,
        },
        Pointer: {
          rect: true,
          y: h => h * 0.5,
          mount: 0.5,
          w: Constants.Pointer.size,
          h: Constants.Pointer.size,
          color: Theme.Colors.Player.Controls.Seekbar.Fill.Default,
          shader: {
            type: Lightning.shaders.RoundedRectangle,
            radius: Constants.Pointer.size * 0.5,
          },
        },
      },
      CurrentTime: {
        x: Constants.CurrentTime.Left,
        y: Constants.CurrentTime.Top,
        text: {
          ...Theme.Fonts.Player.Seekbar.CurrentTime.Font,
          textColor: Theme.Fonts.Player.Seekbar.CurrentTime.TextColor.Default,
          text: '00:00',
        },
      },
      RemainingTime: {
        x: Constants.RemainingTime.Left,
        y: Constants.RemainingTime.Top,
        mountY: 0.5,
        text: {
          ...Theme.Fonts.Player.Seekbar.RemainingTime,
          text: '00:00',
        },
      },
    };
  }

  /**
   * @param {SeekbarInfo} info
   */
  setPosition(info) {
    const totalW = this.tag('ProgressBar').finalW;
    this.tag('ProgressFill').w = info.posPercent * totalW;
    this.tag('Pointer').x = info.posPercent * totalW;

    this.tag('CurrentTime').text.text = info.currTime;
    this.tag('RemainingTime').text.text = info.remainTime;
  }

  /**
   * @param {PlayerController} playerController
   * @param {boolean} enabled
   */
  registerEventHandler(playerController, enabled) {
    this._playerController = playerController;
    this.updateColors(enabled);
    this._playerController.uiEventHandlers.updatePosition = info => {
      this.setPosition(info);
    };
  }

  updateColors(enabled) {
    if (!enabled) {
      this.tag('Pointer').color = Theme.Colors.Player.Controls.Seekbar.Fill.Disabled;
      this.tag('ProgressFill').color = Theme.Colors.Player.Controls.Seekbar.Fill.Disabled;
    } else if (this.hasFocus()) {
      this.tag('Pointer').color = Theme.Colors.Player.Controls.Seekbar.Fill.Focus;
      this.tag('ProgressFill').color = Theme.Colors.Player.Controls.Seekbar.Fill.Focus;
    } else {
      this.tag('Pointer').color = Theme.Colors.Player.Controls.Seekbar.Fill.Default;
      this.tag('ProgressFill').color = Theme.Colors.Player.Controls.Seekbar.Fill.Default;
    }
  }

  _focus() {
    this.tag('Pointer').color = Theme.Colors.Player.Controls.Seekbar.Fill.Focus;
    this.tag('ProgressFill').color = Theme.Colors.Player.Controls.Seekbar.Fill.Focus;
    this.tag('CurrentTime').text.textColor = Theme.Fonts.Player.Seekbar.CurrentTime.TextColor.Focus;
    this._playerController.controlsManager.seekBarFocused = true;
  }

  _unfocus() {
    this.tag('Pointer').color = Theme.Colors.Player.Controls.Seekbar.Fill.Default;
    this.tag('ProgressFill').color = Theme.Colors.Player.Controls.Seekbar.Fill.Default;
    this.tag('CurrentTime').text.textColor = Theme.Fonts.Player.Seekbar.CurrentTime.TextColor.Default;
    this._playerController.controlsManager.seekBarFocused = false;
  }

  _handleLeft() {
    Log.info('Seekbar', 'handle left');
    return this._playerController.controlsManager.handleSeekEvent(false);
  }

  _handleRight() {
    Log.info('Seekbar', 'handle right');
    return this._playerController.controlsManager.handleSeekEvent(true);
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  _handleEnter() {}
}
